var LARGE_BUTTON = {
  height: 40,
  fontSize: 14
};
var MEDIUM_BUTTON = {
  height: 32,
  fontSize: 13
};
var SMALL_BUTTON = {
  height: 24,
  fontSize: 13
};
var XSMALL_BUTTON = {
  height: 20,
  fontSize: 13
};
export var BUTTON_STYLE_PROPERTIES_BY_SIZE_MAP = {
  large: LARGE_BUTTON,
  medium: MEDIUM_BUTTON,
  small: SMALL_BUTTON,
  xsmall: XSMALL_BUTTON
};
export var cssBaseBackgroundVar = "--smar--sds--button--color--background";
export var cssBackgroundRestVar = "--smar--sds--button--color--background--rest";
export var cssBackgroundHoverVar = "--smar--sds--button--color--background--hover";
export var cssTextRestVar = "--smar--sds--button--color--text--rest";
export var cssBaseTextVar = "--smar--sds--button--color--text";
export var cssBaseBorderVar = "--smar--sds--button--color--border";
export var cssBackgroundActiveVar = "--smar--sds--button--color--background--active";
//# sourceMappingURL=constants.js.map